type RegistrationResultStatus = 'success' | 'fail';

export function notifyExternalRegistrationResult(
  registrationStatus: RegistrationResultStatus,
  options?: { paymentStatus?: 'success' | 'failed' }
) {
  const custId = sessionStorage.getItem('external_cust_id') || undefined;

  const payload = {
    source: 'ayeface-webview',
    type: 'registration_result',
    registration_status: registrationStatus,
    payment_status: options?.paymentStatus,
    cust_id: custId,
    timestamp: new Date().toISOString()
  };

  try {
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(payload, '*');
    }
  } catch (error) {
    console.log(error);
  }

  try {
    if (window.opener) {
      window.opener.postMessage(payload, '*');
    }
  } catch (error) {
    console.log(error);
  }

  try {
    const webview = (window as any).ReactNativeWebView;
    if (webview && typeof webview.postMessage === 'function') {
      webview.postMessage(JSON.stringify(payload));
    }
  } catch (error) {
    console.log(error);
  }
}
